import { inject, Service } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { CONSTANTS } from '@shared/constants';
import { isResumableUrl } from '@shared/utils/is-resumable-url';
import { AuthService } from './auth.service';
import { LastUrlStore } from './last-url.store';

@Service()
export class LastPageGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);
  private lastUrlStore = inject(LastUrlStore);

  canActivate(): UrlTree {
    // A stored `lastUrl` can be an auth landing page — either written by an older
    // build or by a navigation this guard itself caused. Resuming one sends an
    // authenticated user to the login screen, so drop it in both branches.
    const lastUrl = this.lastUrlStore.read();
    const resumableUrl = isResumableUrl(lastUrl) ? lastUrl : null;

    if (resumableUrl && this.authService.authenticated()) {
      return this.router.parseUrl(resumableUrl);
    }

    if (this.authService.hasExpiredSession()) {
      this.authService.clearExpiredSession();
    }

    return this.router.createUrlTree([CONSTANTS.ROUTES.LOGIN], {
      queryParams: { redirectUrl: resumableUrl },
    });
  }
}
